<div class="" *ngIf="!loading">
    <mat-form-field style="margin-right: 1rem;" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput placeholder="" [(ngModel)]="order1.email" name="email">
    </mat-form-field>
    
    <mat-form-field appearance="outline">
        <mat-label>Payment status</mat-label>
        <mat-select (selectionChange)="updateStatusSelection($event.value)" [(ngModel)]="order1.financial_status">
          <mat-option *ngFor="let status of statusArray" [value]="status.value" >{{status.label}}
          </mat-option>
        </mat-select>
    </mat-form-field>
    
    <mat-form-field style="margin-right: 1rem;" appearance="outline">
        <mat-label>Payment method</mat-label>
        <input matInput placeholder="" [(ngModel)]="order1.payment_gateway_names" name="paymentMethod">
    </mat-form-field>
    
    <mat-form-field style="margin-right: 1rem;" appearance="outline">
        <mat-label>User_id from shopify</mat-label>
        <input matInput placeholder="" [(ngModel)]="order1.note_attributes[0].value" name="userIdShopify">
    </mat-form-field>
    
    <mat-form-field style="margin-right: 1rem;" appearance="outline">
        <mat-label>Token</mat-label>
        <input matInput placeholder="" [(ngModel)]="order1.note_attributes[1].value" name="userToken">
    </mat-form-field>
</div>

<mat-spinner *ngIf="loading"></mat-spinner>



<!-- CLIENT INFORMATION -->
<mat-accordion *ngIf="!loading">
    <mat-expansion-panel>
        <mat-expansion-panel-header>
        <mat-panel-title>
            Detalles del cliente
        </mat-panel-title>
        <mat-panel-description>
            {{order1.customer.first_name}} {{order1.customer.last_name}} 
        </mat-panel-description>
        </mat-expansion-panel-header>
        
        <!-- CONTENT -->
        <mat-form-field style="margin-right: 1rem;" appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput placeholder="" [(ngModel)]="order1.customer.first_name" name="clientName">
        </mat-form-field>


        <mat-form-field style="margin-right: 1rem;" appearance="outline">
            <mat-label>Country</mat-label>
            <input matInput placeholder="" [(ngModel)]="order1.customer.default_address.country_name" name="countryName">
        </mat-form-field>

    </mat-expansion-panel>
</mat-accordion>

<mat-accordion>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Añadir producto a pedido
            </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Variant ID</mat-label>
            <mat-select (selectionChange)="addProductToOrder($event)"> <!-- [(ngModel)]="product.variant_id" -->
              <mat-option *ngFor="let prod of stockShopifyProducts" [value]="prod" ><span style="display: flex;align-content: space-between !important;">{{prod.product}}     ({{prod.variantId}})</span>
              </mat-option>
            </mat-select>
        </mat-form-field>

    </mat-expansion-panel>

    <mat-expansion-panel *ngFor="let product of order1.line_items">
        <mat-expansion-panel-header>
        <mat-panel-title>
            {{product.product}}
        </mat-panel-title>
        <mat-panel-description>
            ${{product.price}}
        </mat-panel-description>
        </mat-expansion-panel-header>
        
        <!-- CONTENT -->
         <div>
            <ul class="list-unstyled mb-0">
                <li><i class="fe fe-check me-2 text-success"></i>{{product.sku}}</li>
                <li><i class="fe fe-check me-2 text-success"></i>{{product.title}}</li>
            </ul>
    
            <mat-form-field style="margin-right: 1rem;" appearance="outline">
                <mat-label>Variant ID</mat-label>
                <input matInput placeholder="" [(ngModel)]="product.variantId" name="variantId">
            </mat-form-field>
    
            
            <mat-form-field style="margin-right: 1rem;" appearance="outline">
                <mat-label>$ Price</mat-label>
                <input matInput placeholder="" [(ngModel)]="product.price" name="price">
            </mat-form-field>
         </div>

    </mat-expansion-panel>
</mat-accordion>

<div style="margin: 1rem 0;">
    <button mat-raised-button  class="demo-button" (click)="simulateOrder()" [disabled]="!isFormValid()"><i class="fas fa-funnel-dollar"></i>Simular orden</button>
</div>

<!-- RENDER ORDERS -->
<app-shopify-orders></app-shopify-orders>

<app-log-viewer></app-log-viewer>
